/**
 * B10 (fixronde 12-10-2026): zoeken op de dashboards negeert accenten en
 * leestekens. Dezelfde normalisatie op zoekterm en veldwaarde, zodat
 * "dorrec" het dossier "Dörréç" vindt en "jansensmit" ook "Jansen-Smit".
 *
 * - kleine letters;
 * - een paar letters die Unicode-NFD niet splitst, met de hand (ø → o, ß → ss);
 * - NFD en de combinerende tekens weg (é → e, ç → c, ü → u);
 * - alles wat geen letter, cijfer of witruimte is, weg.
 *
 * Witruimte blijft staan: "van den berg" matcht nog steeds alleen in die
 * volgorde, net als voorheen.
 */
const LOSSE_LETTERS: Record<string, string> = {
  ø: "o",
  æ: "ae",
  œ: "oe",
  ß: "ss",
  ł: "l",
  đ: "d",
  ð: "d",
  þ: "th",
  ı: "i",
};
const LOSSE_LETTER = /[øæœßłđðþı]/g;
const COMBINEREND = /[\u0300-\u036f]/g;
const GEEN_LETTER_CIJFER_WIT = /[^\p{L}\p{N}\s]/gu;

function normaliseer(tekst: string): string {
  return tekst
    .toLowerCase()
    .replace(LOSSE_LETTER, (t) => LOSSE_LETTERS[t])
    .normalize("NFD")
    .replace(COMBINEREND, "")
    .replace(GEEN_LETTER_CIJFER_WIT, "");
}

export function normaliseerZoektekst(tekst: string): string {
  return normaliseer(tekst);
}

export interface GenormaliseerdeTekst {
  tekst: string;
  /** Per teken in `tekst`: begin en einde (exclusief) in de brontekst. */
  begin: number[];
  einde: number[];
}

/**
 * Zelfde normalisatie, maar met per uitvoerteken de plek in de brontekst,
 * zodat een treffer in de genormaliseerde tekst terug te vinden is in de
 * oorspronkelijke schrijfwijze (notitiefragment).
 */
export function normaliseerMetPosities(bron: string): GenormaliseerdeTekst {
  let tekst = "";
  const begin: number[] = [];
  const einde: number[] = [];
  let i = 0;
  for (const teken of bron) {
    const uit = normaliseer(teken);
    for (let k = 0; k < uit.length; k++) {
      begin.push(i);
      einde.push(i + teken.length);
    }
    tekst += uit;
    i += teken.length;
  }
  return { tekst, begin, einde };
}
